import React from 'react';
import { t } from 'i18next';
import { EmptyState } from '@/components/custom/empty-state';

export function WeekChallengePlayfulActivities({ conquers }) {
  return (
    <div className="relative h-fit rounded-2xl border border-neutral-lightest p-5 shadow-card">
      <h3 className="mb-4 text-base font-extrabold text-neutral-900">Conquistas da semana</h3>

      {conquers && conquers.length === 0 ? (
        <EmptyState
          type="data"
          text={t('emptyState.achievementsText')}
          variant="plain"
        />
      ) : (
        <div className="flex flex-col gap-4">
          {conquers?.map((item, i) => (
            <div
              key={i}
              className="flex items-start gap-3"
            >
              <span className="flex h-[30px] w-[30px] shrink-0 items-center justify-center text-2xl leading-none">🏆</span>

              <div className="min-w-0 flex-1">
                <h4
                  className="mb-0.5 truncate text-sm font-extrabold text-neutral-900"
                  title={item?.title}
                >
                  {item?.title}
                </h4>
                <p
                  className="mb-0 truncate text-xs text-neutral-dark"
                  title={item?.user?.name}
                >
                  {item?.user?.name}
                </p>
              </div>

              <span className="shrink-0 text-xs font-extrabold text-mission">{item?.['challenge-attempt-items']?.[0]?.score ?? 0}pts</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
